export default {
    page_title: "Kevi | Formulários",
    manage_title: "Gerenciar Formulários",
    new_btn: "Novo Formulário",
    max_reached: "Você atingiu o máximo de {0} formulários",
    modal_rename_title: "Renomear Formulário",
    modal_add_title: "Adicionar Formulário",
    name_label: "Nome:",
    btn_add: "Adicionar",
    btn_save: "Salvar",
    confirm_delete_question: "Tem certeza que deseja excluir o Formulário",
    confirm_delete_body: "Após exclusão, a ação será irreversível.",
    confirm_duplicate_question: "Tem certeza que deseja duplicar o Formulário",
    confirm_duplicate_body: "Após duplicação, o formulário será criado com o mesmo nome.",
    answers: "respostas",
    tooltip_manage: "Gerenciar Perguntas",
    tooltip_view: "Visualizar Formulário",
    tooltip_view_tab: "Visualizar Formulário em nova aba",
    tooltip_report: "Relatório de Respostas",
    tooltip_export: "Exportar Respostas",
    tooltip_duplicate: "Duplicar Formulário",
    tooltip_rename: "Renomear Formulário",
    tooltip_remove: "Remover Formulário",
    notification_duplicated: "Formulário duplicado com sucesso!",
    notification_deleted: "Formulário excluído com sucesso.",
    notification_saved: "Formulário salvo com sucesso.",
    notification_reset: "Formulário resetado com sucesso.",
    btn_cancel: "Cancelar",
    count_forms: "{0} formulários",
    search_placeholder: "Buscar formulário",
    questions_count: "{0} perguntas",
    answers_count: "{0} respostas",
    action_questions: "Perguntas",
    action_answers: "Respostas",
    action_copy_link: "Copiar link público",
    link_copied: "Link copiado para a área de transferência.",
    more_actions: "Mais ações",
    empty_title: "Nenhum formulário ainda",
    empty_subtitle: "Crie seu primeiro formulário para começar a coletar respostas.",
    empty_search: "Nenhum formulário encontrado para essa busca.",
    settings: {
        title: "Dados do cliente",
        subtitle: "Escolha quais dados o formulário pede antes de enviar as respostas.",
        field_askName: "Nome",
        field_askLastName: "Sobrenome",
        field_askEmail: "E-mail",
        field_askPhone: "Telefone",
        field_askBirthdate: "Data de nascimento",
        ask_no: "Não pedir",
        ask_optional: "Opcional",
        ask_required: "Obrigatório",
        btn_save: "Salvar dados",
        notification_saved: "Configurações do formulário salvas.",
    },
    appearance: {
        tooltip: "Configurações do formulário",
        title: "Configurações do formulário",
        subtitle: "Escolha a posição dos dados do cliente e a mensagem de sucesso.",
        position_label: "Posição dos dados do cliente",
        position_below: "Abaixo das perguntas",
        position_above: "Acima das perguntas",
        success_title_label: "Título de sucesso",
        success_title_placeholder: "Obrigado!",
        success_message_label: "Mensagem de sucesso",
        success_message_placeholder: "Sua opinião é muito importante!",
        btn_save: "Salvar configurações",
        notification_saved: "Configurações do formulário salvas.",
    },
    questions: {
        title: "Formulário",
        list_title: "Perguntas",
        count: "{0} perguntas",
        answers_count: "{0} respostas",
        empty_title: "Nenhuma pergunta ainda",
        empty_subtitle: "Adicione a primeira pergunta para montar o seu formulário.",
        open_public: "Abrir formulário",
        btn_back: "Voltar",
        btn_add_question: "Adicionar Pergunta",
        pending_changes: "Você possui alterações pendentes.",
        leave_unsaved: "Você tem alterações pendentes. Se sair agora, elas serão perdidas. Deseja continuar?",
        revert_changes: "Reverter alterações",
        btn_save: "Salvar",
        conditional: "Pergunta condicional",
        answers: "respostas",
        new_question: "Nova pergunta",
        will_remove: "Essa pergunta será removida ao salvar",
        view_answers: "Ver Respostas",
        tooltip_condition: "Adicionar Condição",
        tooltip_delete: "Excluir pergunta",
        copy_id: "Copiar ID da pergunta",
        id_copied: "ID da pergunta copiado",
        tooltip_edit: "Editar pergunta",
        tooltip_undo: "Desfazer remoção",
        type_emotion: "Escala emocional (CSAT)",
        type_comment: "Resposta aberta",
        type_boolean: "Sim ou não",
        type_selectbox: "Múltipla Escolha",
        type_input: "Texto curto",
        type_nps: "Métrica NPS",
        type_date: "Data",
        type_ces: "Métrica CES",
        type_file: "Arquivo",
        type_content: "Texto explicativo",
        type_emotion_hint: "Nota de 1 a 5 com carinhas.",
        type_comment_hint: "Campo aberto para textos longos.",
        type_boolean_hint: "Resposta binária de sim ou não.",
        type_selectbox_hint: "Lista de opções para escolher.",
        type_input_hint: "Campo de texto de uma linha.",
        type_nps_hint: "Nota de 0 a 10 de recomendação.",
        type_date_hint: "Seleção de uma data no calendário.",
        type_ces_hint: "Nota de esforço de 1 a 7.",
        type_file_hint: "Upload de imagens e documentos.",
        type_content_hint: "Bloco de texto formatado, sem resposta.",
        type_table: "Tabela",
        type_table_hint: "Planilha com colunas, linhas e fórmulas.",
    },
    report: {
        page_title: "Kevi | Relatório de Respostas",
        title: "Relatório de Respostas",
        btn_export: "Exportar",
        no_answers_found: "Nenhuma resposta encontrada",
        no_answers_description: "Você já começou a divulgar seu novo programa de fidelidade? Não receba amanhã a opinião que você pode receber hoje.",
        segment_filter: "Segmento do cliente",
    },
    questions_form: {
        close: "Fechar",
        select_type_title: "Selecione o tipo de pergunta",
        back: "Voltar",
        fill_data_title: "Preencha os dados da pergunta",
        edit_title: "Editar pergunta",
        type_locked: "(não pode ser alterado)",
        remove_option: "Remover opção",
        undo_remove_option: "Desfazer remoção da opção",
        content_label: "Conteúdo exibido no formulário",
        content_hint: "Selecione o texto para formatar com títulos, negrito, itálico e listas.",
        placeholder_content: "Conte aqui o que o cliente precisa saber antes de responder.",
        error_content: "Escreva o conteúdo que será exibido no formulário",
        impact_hint: "Essa pergunta já tem {0} respostas. Alterar o texto ou as opções muda como elas aparecem nos relatórios.",
        impact_title: "Essa alteração afeta relatórios anteriores",
        impact_body: "Essa pergunta já foi respondida {0} vezes.",
        impact_body_extra: "As respostas já registradas passarão a ser exibidas com o novo texto e as novas opções em todos os relatórios e exportações.",
        impact_confirm: "Alterar mesmo assim",
        type_label: "Tipo:",
        question_text_label: "Texto da sua pergunta:",
        multiselect_label: "Múltipla seleção",
        multiselect_hint: "Permite múltipla seleção dentre as opções propostas.",
        options_label: "Opções:",
        option_will_remove: "Essa opção será removida ao salvar",
        btn_add_option: "Nova Opção",
        btn_save_question: "Salvar Pergunta",
        btn_add_question: "Adicionar Pergunta",
        error_question: "Deve especificar o texto da sua pergunta corretamente",
        error_options: "Deve especificar ao menos duas opções para a lista, além de preencher todas corretamente com o mínimo de dois caracteres.",
        placeholder_default: "Como estava a comida?",
        placeholder_selectbox: "Onde conheceu nossos serviços?",
        placeholder_date: "Dia em que você nos visitou",
        placeholder_file: "Envie a arte ou o logo da sua empresa",
        placeholder_option: "Opção {0}",
        file_multiple_label: "Permitir múltiplos arquivos",
        file_multiple_hint: "Permite que o cliente envie mais de um arquivo nessa pergunta.",
        file_max_files_label: "Máximo de arquivos:",
        file_types_label: "Tipos de arquivo aceitos:",
        file_types_any: "Qualquer tipo permitido pela Kevi",
        file_types_image: "Somente imagens",
        file_types_image_dst: "Imagens ou bordado (.DST)",
        file_types_dst: "Somente bordado (.DST)",
        file_formats_hint: "O limite global é de 30 MB por arquivo.",
        placeholder_table: "Quais produtos e quantidades você quer encomendar?",
    },
    report_component: {
        answers: "respostas",
        general_assessment: "Avaliação geral",
        no_answers: "Por enquanto ninguém respondeu essa pergunta.",
        see_all_answers: "Ver respostas completas",
        grade_very_good: "Muito bom",
        grade_good: "Bom",
        grade_neutral: "Neutro",
        grade_bad: "Ruim",
        grade_very_bad: "Muito ruim",
        boolean_yes: "Sim",
        boolean_no: "Não",
        nps_promoter: "Promotor",
        nps_neutral: "Neutro",
        nps_detractor: "Detrator",
        ces_label_1: "Extremamente difícil",
        ces_label_2: "Muito difícil",
        ces_label_3: "Difícil",
        ces_label_4: "Aceitável",
        ces_label_5: "Fácil",
        ces_label_6: "Muito fácil",
        ces_label_7: "Extremamente fácil",
        selectbox_view: "Visualizar",
        selectbox_list: "Lista",
        selectbox_chart: "Gráfico",
    },
    conditions: {
        modal_title: "Condições de exibição",
        header_text: "Utilize as condições para criar formulários dinâmicos e personalizados, permitindo que você controle a visibilidade das perguntas com base nas respostas fornecidas em perguntas anteriores (por isso, a primeira pergunta não pode ter condições).",
        no_previous_warning: "A primeira pergunta não pode ter condições, pois não há perguntas anteriores para basear a condição.",
        btn_cancel: "Cancelar",
        btn_confirm: "Confirmar",
        error_fill_all: "Por favor, preencha todos os campos das condições antes de salvar.",
        operator_label: "Operador:",
        operator_and: "E (todas as condições)",
        operator_or: "OU (qualquer condição)",
        btn_add_condition: "Adicionar Condição",
        btn_add_group: "Adicionar Grupo",
        remove_condition: "Remover condição",
        remove_group: "Remover grupo",
        empty_message: "Adicione condições ou grupos para criar sua lógica",
        condition_label: "Condição",
        question_label: "Pergunta",
        select_placeholder: "Selecione...",
        operator_select_label: "Operador",
        value_label: "Valor",
        value_placeholder: "Digite o valor",
        emotion_1: "1 - Muito Insatisfeito",
        emotion_2: "2 - Insatisfeito",
        emotion_3: "3 - Neutro",
        emotion_4: "4 - Satisfeito",
        emotion_5: "5 - Muito Satisfeito",
        boolean_yes: "Sim",
        boolean_no: "Não",
        op_equal: "Igual a",
        op_not_equal: "Diferente de",
        op_greater_than: "Maior que",
        op_greater_than_or_equal: "Maior ou igual a",
        op_less_than: "Menor que",
        op_less_than_or_equal: "Menor ou igual a",
        op_includes: "Contém",
        op_answered: "Respondida",
    },
    embed: {
        title: "Usar este formulário no meu site",
        subtitle: "Copie o código para mostrar o formulário na sua página ou enviar as respostas pelo seu próprio formulário.",
        tab_link: "Link direto",
        tab_iframe: "Via iframe",
        tab_js: "Integração via código",
        copy: "Copiar",
        copied: "Copiado",
        copied_toast: "Código copiado",
        link_help: "Use este link para abrir o formulário em uma página própria, WhatsApp, e-mail ou qualquer outro canal.",
        iframe_lead: "Pouco técnico e funciona rápido — ideal para colocar o formulário Kevi no site com pouca customização.",
        sdk_step: "1. Instale o SDK da Kevi",
        sdk_help: "Coloque este código no Google Tag Manager ou no <head> do seu site. Ele ajusta a altura do iframe e avisa quando o formulário for enviado.",
        sdk_snippet_label: "SDK da Kevi",
        iframe_step: "2. Cole o iframe na página",
        iframe_help: "Depois do SDK, cole este código no HTML onde o formulário deve aparecer.",
        iframe_snippet_label: "Código do iframe",
        js_lead: "Customização total: pluga a Kevi em um formulário 100% do seu site, com a sua UI e as suas regras.",
        js_help: "Envie as respostas do seu formulário para a Kevi com este código. Os IDs abaixo são deste formulário.",
        js_snippet_label: "Código JavaScript",
        js_note_omit: "Omita do payload as perguntas que o visitante não respondeu.",
        js_note_validate: "A validação dos campos obrigatórios fica no seu site — a API aceita envios parciais.",
        js_note_response: "Em caso de sucesso a API devolve answer, coupon e client. Se você usa o SDK, pode passar client para kevi.setClient().",
        questions_title: "Perguntas e IDs",
        questions_help: "Use estes IDs como chaves em steps_questions. Clique no ID para copiar.",
        questions_empty: "Salve o formulário com pelo menos uma pergunta para gerar o código com IDs.",
        format_emotion: "Número de 1 a 5",
        format_nps: "Número de 0 a 10",
        format_ces: "Número de 1 a 7",
        format_boolean: "\"1\" (sim) ou \"0\" (não)",
        format_selectbox: "Array com o texto das opções",
        format_input: "Texto",
        format_comment: "Texto",
        format_date: "Data no formato YYYY-MM-DD",
        format_file: "Array de arquivos {url, name, type, size} após POST /form/{id}/upload",
        format_table: "Objeto {values: [[...], ...]} com uma lista por linha, na ordem das colunas",
    },
    table: {
        rows_mode: "Tipo de linhas",
        mode_dynamic: "Linhas livres",
        mode_fixed: "Linhas fixas",
        mode_dynamic_hint: "O cliente adiciona quantas linhas precisar. Configure abaixo como é cada linha.",
        mode_fixed_hint: "Você define as linhas. Escreva o nome de cada linha na primeira coluna.",
        paste_button: "Colar do Excel",
        paste_placeholder: "Cole aqui as células copiadas do Excel ou do Google Sheets",
        paste_hint: "A primeira linha vira o título das colunas. Isso substitui a tabela atual.",
        paste_apply: "Criar tabela",
        paste_skipped: "{0} células coladas foram ignoradas porque não cabem nessa posição.",
        view_edit: "Editar",
        view_test: "Testar",
        formula_bar_hint: "Clique numa célula para escrever um valor padrão ou uma fórmula começando com =",
        lock_hint: "Travada: o cliente vê o valor padrão e não pode alterar",
        lock: "Travar",
        locked: "Travada",
        drag_hint: "Arraste para mudar a coluna de lugar",
        column_menu: "Opções da coluna",
        add_column: "Adicionar coluna",
        row_label_header: "Linha",
        column_title_placeholder: "Título",
        row_label_placeholder: "Nome da linha",
        move_up: "Mover para cima",
        move_down: "Mover para baixo",
        remove_row: "Remover linha",
        each_row: "cada linha",
        add_row: "Adicionar linha",
        remove_summary: "Remover linha de resumo",
        summary_label_placeholder: "Nome do resumo",
        add_summary: "Adicionar linha de resumo",
        summary_hint: "Linhas de resumo usam fórmulas como =SUM(B:B) para somar a coluna inteira.",
        summary_default_label: "Total",
        summary_row: "Resumo",
        row: "Linha",
        rows_min: "Mínimo de linhas",
        rows_max: "Máximo de linhas",
        add_label: "Texto do botão de adicionar",
        add_row_default: "Adicionar linha",
        rows_min_hint: "Com mínimo 0 a pergunta é opcional.",
        value_number: "Número da resposta",
        value_number_default: "Quantidade de linhas preenchidas",
        value_number_hint: "Usado em automações e relatórios como o valor numérico dessa resposta.",
        value_number_invalid: "{0} (célula não existe mais)",
        test_hint: "Preencha como o cliente vai preencher. Nada aqui é salvo.",
        preview_desktop: "Computador",
        preview_mobile: "Celular",
        column: "Coluna",
        column_type: "Tipo",
        type_text: "Texto",
        type_number: "Número",
        type_select: "Lista de opções",
        type_date: "Data",
        required: "Preenchimento obrigatório",
        alias: "Apelido",
        alias_placeholder: "ex.: preco",
        min_width: "Largura mínima (px)",
        alias_hint: "O apelido pode ser usado nas fórmulas no lugar da letra da coluna.",
        number_min: "Mínimo",
        number_max: "Máximo",
        number_decimals: "Casas decimais",
        number_prefix: "Prefixo",
        number_suffix: "Sufixo",
        move_left: "Esquerda",
        move_right: "Direita",
        duplicate: "Duplicar",
        remove_column: "Remover coluna",
        formula_error: "Erro na fórmula: {0}",
        default_item: "Item",
        default_quantity: "Quantidade",
        error_formula_column: "Fórmulas só podem ser usadas em colunas de número.",
        error_summary_value: "Linhas de resumo aceitam apenas fórmulas (comece com =).",
        error_number: "Digite um número, por exemplo 10 ou 1,5.",
        error_date: "Use uma data no formato AAAA-MM-DD.",
        error_select: "Esse valor não está nas opções da coluna.",
        error_column_type: "Coluna {0}: tipo inválido.",
        error_select_options: "Coluna {0}: adicione pelo menos uma opção.",
        error_select_duplicate: "Coluna {0}: há opções repetidas.",
        error_min_max: "Coluna {0}: o mínimo é maior que o máximo.",
        error_decimals: "Coluna {0}: use de 0 a 6 casas decimais.",
        error_fixed_empty: "Adicione pelo menos uma linha.",
        error_fixed_max: "No máximo {0} linhas fixas.",
        error_rows_min: "O mínimo de linhas deve ser 0 ou mais.",
        error_rows_max: "O máximo de linhas deve ficar entre 1 e {0}.",
        error_rows_min_max: "O mínimo de linhas é maior que o máximo.",
        error_summary_max: "No máximo {0} linhas de resumo.",
        error_cell_number: "{0}: o valor padrão não é um número.",
        error_cell_select: "{0}: o valor padrão não está nas opções.",
        error_cell_date: "{0}: o valor padrão não é uma data válida.",
        error_summary_value_at: "{0}: linhas de resumo aceitam apenas fórmulas.",
        error_ref_removed: "{0}: a fórmula cita uma célula que foi removida (#REF).",
        error_value_number: "O número da resposta aponta para uma célula que não existe mais.",
        error_empty: "Configure a tabela.",
        error_summary: "A tabela tem {0} problema(s) para corrigir antes de salvar.",
        error_server: "A tabela \"{0}\" não pôde ser salva: {1}",
    },
};
